import { ToggleSkipConfirmationTypes } from "../nps-modal/nps-modal.types";

export interface IUseNpsThankyouAndSkipConfirmationScreenProps {
  handleModalClose: () => void;
  toggleSkipConfirmation: (
    from:
      | ToggleSkipConfirmationTypes.PARENT_PHONE_NUMBER_SCREEN
      | ToggleSkipConfirmationTypes.SKIP_CONFIRMATION_SCREEN
  ) => void;
}

export enum NpsThankyouAndSkipConfirmationScreenVariants {
  SUBMIT_PHONE_NUMBER = "thankyouAfterSubmittingPhoneNumber",
  SKIP_CONFIRMATION = "skipConfirmation",
  SUBMIT_FEEDBACK = "thankyouAfterSubmittingFeedback"
}

export interface IUseNpsThankyouAndSkipConfirmationScreen {
  handleProceed: (
    variant:
      | NpsThankyouAndSkipConfirmationScreenVariants.SUBMIT_FEEDBACK
      | NpsThankyouAndSkipConfirmationScreenVariants.SKIP_CONFIRMATION
      | NpsThankyouAndSkipConfirmationScreenVariants.SUBMIT_PHONE_NUMBER
  ) => void;
  handleSeeYouLater: () => void;
}

export interface INpsThankyouAndSkipConfirmationScreen {
  variant:
    | NpsThankyouAndSkipConfirmationScreenVariants.SKIP_CONFIRMATION
    | NpsThankyouAndSkipConfirmationScreenVariants.SUBMIT_FEEDBACK
    | NpsThankyouAndSkipConfirmationScreenVariants.SUBMIT_PHONE_NUMBER;
  handleModalClose: () => void;
  toggleSkipConfirmation: (
    from:
      | ToggleSkipConfirmationTypes.PARENT_PHONE_NUMBER_SCREEN
      | ToggleSkipConfirmationTypes.SKIP_CONFIRMATION_SCREEN
  ) => void;
}
